module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/206cb8cbe47d0d7fb13df3dbf3c84fac.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/close-icon.svg
// module id = Xotz
// module chunks = 1